import React, { useState, useCallback } from 'react'
import intl from 'react-intl-universal'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Stepper } from 'antd-mobile'
import { CloseOutline } from 'antd-mobile-icons'
import styles from './index.module.less'
import CurrencySymbol from '../../../components/CurrencySymbol'
import { selectProductAttr, selectProductGroupAttr, selectProductSpec, setQuantity, selectProductQuantity } from '../../../store/reducers/cart'

import { replaceCDNDomain, groupBy } from '../../../utils'
import { culTaxAndServiceFee, getDisplayOriginPrice, getPriceSource, getProductBasePrice, isPackagePriceFree, shouldShowAsFree, shouldShowPackageDiscount, sumAttrArrAmount, sumAttrArrOriginAmount } from '../../../utils/price'
import math, { formatNumber } from '../../../utils/math'
import { addBehaviorsRecord } from '../../../utils/BehaviorstatsHelp'

import Article from '../../../components/Article'
import ProductAttrBox from '../../../components/ProductAttrBox'
const INITIAL_STATE = {
  totalPrice: 0,
  subAttrList: [],
  loading: false,
  checkedAttr: {
    attr: null,
    subAttr: null
  },
  orderId: '',
  checkBookingDate: null,
  checkBookingTime: null,
  dateColumns: [],
  timeColumns: [],
  dateVisible: false,
  timeVisible: false,
  storeInfo: {},
  priceItem: {},
  quantity: 1
}

export default function RelateAttrModal({ product,
  onCallback,
  iconData,
  addToCart,
  from,
  ownCount = 0,
  showIntro = true,
  showStepper = false,
  buttonText,
  limitCount = 0,
  placeFlag = 0
}) {
  const [state, setState] = useState(INITIAL_STATE)
  const dispatch = useDispatch()
  const quantity = useSelector(selectProductQuantity)
  const attr = useSelector(selectProductAttr)
  const groupAttr = useSelector(selectProductGroupAttr)
  const spec = useSelector(selectProductSpec)


  const { specItem } = spec
  const { attrArr = [] } = attr
  const { attrArr: groupAttrArr = [] } = groupAttr
  const priceSource = getPriceSource({ ...product, specItem })
  const specAmount = getProductBasePrice(priceSource)
  const specOriginAmount = getDisplayOriginPrice(priceSource)
  const groupAttrAmount = sumAttrArrAmount(groupAttrArr)
  const normalAttrAmount = sumAttrArrAmount(attrArr)
  const attrAmount = math.add(normalAttrAmount, groupAttrAmount)
  const attrOriginAmount = math.add(sumAttrArrOriginAmount(attrArr), sumAttrArrOriginAmount(groupAttrArr))
  const amount = isPackagePriceFree(priceSource) ? 0 : math.add(specAmount, attrAmount)
  const originAmount = math.add(specOriginAmount, attrOriginAmount)
  const priceObj = culTaxAndServiceFee(amount, state.storeInfo, amount)
  // console.log(attr, '===//')
  // console.log(spec, '===//', amount, '////====amount====', priceObj)

  const handleAddToCart = useCallback((item) => {

    //render new product attri
    const nList = attrArr.concat(groupAttrArr)
    const nObj = {
      attrArr: nList,
      attrKeys: nList.map(item => item.productExtraAttrKey).join(','),
      subAttrKeys: nList.map(item => item.productExtraAttrSubKey).join(',')
    }


    const obj = {
      ...product,
      // ...attr,
      ...nObj,
      ...spec,
      quantity: quantity
    }
    addToCart(obj)
    onCallback && onCallback()

    if (product.addBehavior) {
      addBehaviorsRecord({
        behaviorType: 160200,
        behavior: 160209,
        storeId: product.storeId,
        value1: '+',
        value2: placeFlag
      })
    }

  }, [product, attr, groupAttr, spec, onCallback, addToCart, quantity])

  const isDisabled = () => {
    const hasAttr = product.attrs?.length > 0
    const noAttr = !hasAttr

    let groupAttrLen = 0;
    let normalAttrLen = 0;
    let normalArr = [];
    if (product.attrs?.length > 0) {
      const nGroupAttrs = product.attrs.filter(item => item.groupKey)
      if (nGroupAttrs.length > 0) {
        const groupObj = groupBy(nGroupAttrs, 'groupKey') || {}
        groupAttrLen = Object.keys(groupObj).length
      }

      normalArr = product.attrs.filter(item => !item.groupKey)
      normalAttrLen = normalArr.length
    }

    const hasSpec = product.specs?.length > 0
    const noSpec = product.specs?.length === 0

    if (noAttr && noSpec) {
      return false
    }

    if (noAttr && hasSpec) {
      return !specItem
    }

    // const hasGroupName = product.attrs[0].groupName && product.attrs[0].groupName.indexOf('@@') > -1
    // if (hasGroupName) {
    //   return attrArr.length === 0
    // }

    // const totalOptionNum = product.attrs?.filter(item => !item.groupKey).reduce((sum, item) => sum + item.optionalNum, 0)
    // const subAttrAmount = attrArr.reduce((sum, item) => sum + item.quantity, 0)
    //if (totalOptionNum > 1) {
      //return subAttrAmount < totalOptionNum
    // }

    const attrFlag = []
    if (normalArr.length > 0) {      
      normalArr?.forEach(attr => {
        const results = attrArr.filter(item => item.productExtraAttrKey === attr.attrKey)
        if (attr.optionalNum > 0) {
          const resultQuantity = results.reduce((sum, item) => sum + item.quantity, 0)
          if (resultQuantity === attr.optionalNum) {
            attrFlag.push(true)
          } else {
            attrFlag.push(false)
          }
        }
      })
      // console.log(attrFlag, '=====///=======attrFlag====')

    }
    // console.log(totalOptionNum, '====////totalOptionNum====')

    const noCheckGroupAttr = groupAttrLen === 0 || (groupAttrLen > 0 && groupAttrArr.length === groupAttrLen)
    // const noCheckNormalAttr = normalAttrLen === 0 || (normalAttrLen > 0 && attrArr.length === normalAttrLen)
    // 当 totalOptionNum === -1 时，不限制数量，只要至少选择了一个属性即可
    // const noCheckNormalAttr = normalAttrLen === 0 || (totalOptionNum === -1 && attrArr.length > 0) || (normalAttrLen > 0 && totalOptionNum !== -1 && attrArr.length === normalAttrLen)
    const noCheckNormalAttr =  normalAttrLen === 0 || (normalAttrLen > 0 && attrFlag.every(item => item === true))
    const noCheckedAttr = hasAttr && (!noCheckGroupAttr || !noCheckNormalAttr)
    // const noCheckedAttr = hasAttr && !attrArr.length
    return noCheckedAttr


  }

  const maxStock = limitCount > 0 ? (product.orderMaxNum - limitCount) : (product.orderMaxNum || (product.stock === -1 ? 99 : product.stock))

  return (
    <div className={styles.attrModalWrapper}>
      <div className={`${styles.modalMainBox} p10 bg-white `}>
        {iconData && iconData.imageUrl && (
          <div className={styles.modalIconBox}>
            <div className={styles.iconWrapper}>
              <img src={replaceCDNDomain(iconData.imageUrl)} alt={iconData.name} />
            </div>
          </div>
        )}

        <div className={`${styles.modalContent} jm-modal-content`}>
          {
            from !== 'detail' && (
              <div className={styles.modalTitle}>{product.productName || product.name}</div>
            )
          }
          <div className={styles.modalDesc} style={{ display: 'none' }}>
            {showIntro && product.description && <Article list={product.description} />}
          </div>
          <div
            className={`${styles.modalMain} jm-modal-main`}
            data-from={from}
            style={from === 'detail' ? { maxHeight: '50vh' } : {}}
          >
            {
              (product.attrs?.length > 0 || product.specs?.length > 0) && (
                <div className={`${styles.attrList} ${styles.contentBox}`}>
                  <ProductAttrBox product={product} />
                </div>
              )
            }

            {showStepper && <div className='jm-flex' style={{ justifyContent: 'space-between' }}>
              <div>{intl.get('t_amount').d('数量')}: </div>
              <Stepper
                value={quantity}
                min={1}
                max={maxStock}
                onChange={(value) => {
                  dispatch(setQuantity(value))
                }} />
            </div>}
            <br />
          </div>
        </div>

        <div className={`${styles.modalFooter} jm-flex`}>
          <div className='jm-flex-item'>
            <b className='jm-price fs-18'>
              {isPackagePriceFree(priceSource) && amount === 0 ? (
                <>
                  <CurrencySymbol currency={product.currency || product.currencyCode} />
                  {formatNumber(0)}
                </>
              ) : shouldShowAsFree(priceSource) && amount === 0 ? (
                intl.get('free').d('免费')
              ) : (
                <>
                  <CurrencySymbol currency={product.currency || product.currencyCode} />
                  {formatNumber(amount)}
                </>
              )}
              {shouldShowPackageDiscount(priceSource) && originAmount > amount && (
                <small style={{ display: 'block', color: '#777', textDecoration: 'line-through', fontWeight: 400 }}>
                  <CurrencySymbol currency={product.currency || product.currencyCode} />
                  {formatNumber(originAmount)}
                </small>
              )}
            </b>
            {
              Object.keys(priceObj).length > 0 && priceObj.totalPrice > 0 && (
                <div className='fs-12'>
                  <small className={priceObj.pd_tax_cls}>Tax Fee: {formatNumber(priceObj.pd_tax)}&nbsp;</small>
                  <small className={priceObj.pd_service_cls}>Service Fee: {formatNumber(priceObj.pd_service)}&nbsp;</small>
                </div>
              )}
          </div>
          <div>
            <Button
              size='small'
              loading={state.loading}
              // disabled={product.attrs?.length > 0 && !state.checkedAttr.subAttr}
              disabled={isDisabled()}
              className={`jm-btn ${styles.footerBtn}`}
              onClick={() => handleAddToCart(product)}
            >
              {buttonText || intl.get('update_cart').d('Add to Basket')}
              {
                from === 'detail' && ownCount > 0 && (
                  <span >({ownCount})</span>
                )
              }
            </Button>
          </div>
        </div>
      </div>
      {
        from !== 'detail' && (<div className={styles.modalClose}>
          <CloseOutline
            fontSize={28}
            color='#fff'
            onClick={() => onCallback?.()}
          />
        </div>)
      }


    </div>

  )
}
